/* src/components/version/version.component.scss */
:host {
  display: block;
}
.version-tooltip {
  cursor: help;
}
.version-tooltip__content {
  padding: 0.3rem 0;
  font-size: 0.75rem;
  font-weight: var(--vwui-font-weight-semibold);
}
.version-tooltip__entry {
  display: flex;
}
.version-tooltip__date {
  white-space: nowrap;
  padding: 0.15em 0.8em 0 0;
}
.version-tooltip__subject {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
/*# sourceMappingURL=version.component-BFSSX4XM.css.map */
